import { get, IHttpRequestConfig, put } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { IEmailPreferences } from "./types";

const API = {
  get: "/api/users/email-preferences",
  put: "/api/users/email-preferences",
};

export interface IFetchEmailPreferencesParams {
  companyId?: number;
}

export const fetchEmailPreferences = (params: IFetchEmailPreferencesParams, options?: IHttpRequestConfig) => {
  const { companyId, ...restParams } = params;
  const url = compose(API.get, {}, restParams);

  return get<IEmailPreferences>(url, applyHeaders({ companyId }, options)).then(extractDataFromResponse);
};

export interface IPostEmailPreferencesParams {
  companyId?: number;
}

export const putEmailPreferences = (
  params: IPostEmailPreferencesParams,
  data?: Partial<IEmailPreferences>,
  options?: IHttpRequestConfig,
) => {
  const { companyId, ...restParams } = params;
  const url = compose(API.put, {}, restParams);

  return put<IEmailPreferences>(url, data, applyHeaders({ companyId }, options)).then(extractDataFromResponse);
};
